import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core'
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms'
import { MatButton } from '@angular/material/button'
import { MatProgressSpinner } from '@angular/material/progress-spinner'
import { SnackbarCustomService } from '../../../../shared/components/snackbar/snackbar-custom.service'
import {
  ErrorRequestModel,
  ResponseRequestModel,
} from '../../../../core/models/response.model'
import { MatInputModule } from '@angular/material/input'
import { MatOption } from '@angular/material/core'
import { MatSelect } from '@angular/material/select'
import { ContactTypeService } from '../../../../core/services/contact/contact-type/contact-type.service'
import { ContactService } from '../../../../core/services/contact/contact/contact.service'

@Component({
  selector: 'contact-client-edit-form',
  imports: [
    FormsModule,
    MatButton,
    MatProgressSpinner,
    ReactiveFormsModule,
    MatInputModule,
    MatOption,
    MatSelect,
  ],
  templateUrl: './contact-client-edit-form.component.html',
  styleUrl: './contact-client-edit-form.component.scss',
  providers: [ContactTypeService, ContactService],
  standalone: true,
})
export class ContactClientEditFormComponent implements OnInit, OnChanges {
  constructor(
    private formBuilder: FormBuilder,
    private snackbar: SnackbarCustomService,
    private contactTypeService: ContactTypeService,
    private contactService: ContactService,
  ) {}

  form: FormGroup = new FormGroup({})
  loading = false

  @Output() response = new EventEmitter()
  @Input() editItem: any = {}
  @Input() personId = 0

  listType: any[] = []

  ngOnInit(): void {
    this.getListType()
    this.createForm()
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['editItem']) {
      this.treatmentItem()
    }
  }

  private treatmentItem() {
    if (this.checkEdit()) {
      this.form.reset()
      this.fillForm()
    }
  }

  getListType() {
    this.contactTypeService.listContactType().subscribe({
      next: (response: ResponseRequestModel) => {
        this.listType = response.data
      },
      error: (err: ResponseRequestModel) => {
        console.error(err)
      },
      complete: () => {},
    })
  }

  checkEdit() {
    if (this.editItem) {
      if (this.editItem.edit) {
        return true
      } else {
        return false
      }
    } else {
      return false
    }
  }

  fillForm() {
    this.form.get('description')?.setValue(this.editItem.data.descricao)
    this.form.get('typeContact')?.setValue(this.editItem.data.tipoContatoId)
  }

  resetForm() {
    this.form.reset()
  }

  createForm(): void {
    this.form = this.formBuilder.group({
      description: ['', [Validators.required]],
      typeContact: ['', [Validators.required]],
    })
  }

  createContact() {
    this.loading = true
    const model = this.createModel()
    this.contactService.createContact(model).subscribe({
      next: (response: any) => {
        this.snackbar.success(response.message)
        this.response.emit({ refresh: true, clear: true })
        this.resetForm()
        this.loading = false
      },
      error: (err: ErrorRequestModel) => {
        this.loading = false
        this.snackbar.errorRequest(err)
      },
      complete: () => {
        this.loading = false
      },
    })
  }

  editContact() {
    this.loading = true
    const model = this.createModel(true)
    this.contactService.editContact(model).subscribe({
      next: (response: any) => {
        this.snackbar.success(response.message)
        this.response.emit({ refresh: true, clear: true })
        this.resetForm()
        this.loading = false
      },
      error: (err: ErrorRequestModel) => {
        this.loading = false
        this.snackbar.errorRequest(err)
      },
      complete: () => {
        this.loading = false
      },
    })
  }

  cancel() {
    this.response.emit({ refresh: false, clear: true })
    this.resetForm()
  }

  createModel(edit = false) {
    if (edit) {
      return {
        id: this.editItem.data.id,
        pessoaId: this.personId,
        descricao: this.form.controls['description'].value,
        tipoContatoId: this.form.controls['typeContact'].value,
      }
    } else {
      return {
        pessoaId: this.personId,
        descricao: this.form.controls['description'].value,
        tipoContatoId: this.form.controls['typeContact'].value,
      }
    }
  }
}
